// Automatically generated
export const USE_CHECKBOX_STATE_KEYS = [
  "defaultState",
  "state",
  "onStateChange",
] as const;
export const CHECKBOX_STATE_KEYS = ["state", "setState"] as const;
export const CHECKBOX_KEYS = [
  ...CHECKBOX_STATE_KEYS,
  "value",
  "checked",
] as const;
